import React,{useState} from 'react';
import { CircularProgress } from '@material-ui/core';
import { Document, Page } from "react-pdf";
import { pdfjs } from "react-pdf";
import ChevronWhite from 'assets/icon/chevron-white.png'
import Download from 'assets/icon/Download.png'
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { useWindowWidth } from '@wojtekmaj/react-hooks';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
const renderLoading=()=>{
  return <div style={{width:'100%',height:200}} className='div-flex div-justify-center div-align-center'><CircularProgress  /></div>
}
const PdfViewer = ({
  url, 
}) => { 
  const width = useWindowWidth();
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [load, setload] = useState(true)
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setload(true)
  }
  function changePage(offset) {
    setPageNumber(prevPageNumber => prevPageNumber + offset);
  }

  function previousPage() {
    if(pageNumber>1){
      changePage(-1);

    }
  }

  function nextPage() {
    if(numPages>pageNumber){
      changePage(1);

    }
  }
  // console.log(`object`, object)
  function onLoadError() {
    setload(false)
  }
  return(
    <div style={{position:'relative'}}>
      <Document  loading={()=>renderLoading()} file={url} onLoadError={onLoadError} onLoadSuccess={onDocumentLoadSuccess}>
        <Page
          pageNumber={pageNumber}
          width={Math.min(width * 0.9, 400)}
        
        />
      </Document>
      {load&&<div className='pdf-chevron-left' onClick={previousPage}>
        <img src={ChevronWhite}/>
      </div>}
      {load&&<div className='pdf-chevron-right' onClick={nextPage}>
        <img src={ChevronWhite}/>
      </div>}
      {load&&<div className='pdf-info-slide'>
         <p className='font-nunito margin-0'>Page {pageNumber || (numPages ? 1 : '--')} of {numPages || '--'}</p>
         <div onClick={()=>window.open(url,'_blank')} style={{position:'absolute',right:20,cursor:'pointer'}}>
         <img src={Download} style={{justifySelf:'flex-end',width:15}}/>
         </div>
      </div>}
    </div>
  )
};

export default PdfViewer;